import { businessesAdapter } from './businesses.slice';
import { store, RootState } from '../../store';

export const businessesSelectors = businessesAdapter.getSelectors((state: RootState) => state.businesses)
export const allBusinesses = businessesSelectors.selectAll(store.getState())